import { useDayjs } from '#dayjs'
import type { Dayjs } from 'dayjs';
import duration from 'dayjs/plugin/duration';

const dayjs = useDayjs()
dayjs.extend(duration);

export const dateFormat = (date: Date, type: 'date' | 'month' | 'year' | 'date-int' | 'time' | 'military-time' | 'dateday') => {
    if(date) {
        switch(type) {
            case 'date':
                return dayjs(date).format('DD/MM/YYYY');
            case 'date-int':
                return dayjs(date).format('YYYY-MM-DD');
            case 'time':
                return dayjs(date).format('h:mm a');
            case 'military-time':
                return dayjs(date, "HH:mm").add(1, "day").format("HH:mm");
            case 'dateday':
                return dayjs(date).format('DD/MM/YYYY ddd');
            case 'month':
                return dayjs(date).format('MM');
            case 'year':
                return dayjs(date).format('YYYY');
        }
    }
    return null
}

export const combinedDateAndTime = (time: string) => {
    return `${dayjs().format('YYYY-MM-DD')}T${time}:00`
}

export const combinedDateAndTimeAsDayJs = (date: string | Dayjs, time: string | Dayjs): Dayjs => {
    const dayjsDate = dayjs(date);
    const dayjsTime = dayjs(time, 'hh:mmA');
    console.log(dayjsDate);
    console.log(dayjsTime)

    const combined = dayjsDate
      .hour(dayjsTime.hour())
      .minute(dayjsTime.minute())
      .second(dayjsTime.second())
      .millisecond(dayjsTime.millisecond());

    return combined;
};

export const dateFormatISO = (date: Date | Dayjs | string | null | undefined) => {
    if(date) {
        let dayjsObject = dayjs(date);

        if (dayjsObject.isValid()) {
            return dayjsObject.format('YYYY-MM-DDTHH:mm:ss');
        }
    }
    return null
}